<script lang="ts" setup>
import FileUploadingGrid from "@/views/trips/components/FileUploadingGrid.vue";
import EmailList from "@/components/lists/EmailList.vue";
import type { TripUpdate, TripUpdatePreview } from "@/api/trips/dto/update";
import { computed } from "vue";
import { useBaseView } from "@/composables";
import { useI18n } from "vue-i18n";
import { CheckCallType } from "@/api/trips/dto/check-call";

const { getPreviewPath } = useBaseView();
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    update: TripUpdate | TripUpdatePreview;
    checkCallType: CheckCallType;
    shouldTransformFiles?: boolean;
  }>(),
  {
    shouldTransformFiles: false,
  },
);

const files = computed(() => {
  if (!props.update.files) {
    return [];
  }

  if (!props.shouldTransformFiles) {
    return props.update.files;
  }

  return props.update.files.map((file) => {
    return {
      ...file,
      previewPath: getPreviewPath(file),
    };
  });
});

const isLoadOrUnloadCheckCallType = computed(() => {
  console.log("update", props.update);
  return props.checkCallType === CheckCallType.loadVerify || props.checkCallType === CheckCallType.unloadVerify;
});
</script>

<template>
  <div class="bg-grey-lighten-4 px-4 py-5 rounded">
    <div>
      <div class="text-grey-darken-1">Subject:</div>

      <p class="text-grey-darken-3 font-size-16 font-weight-500 mt-2">
        {{ update.subject }}
      </p>
    </div>

    <email-list v-if="update.emailRecipients.length" :emails="update.emailRecipients" class="mt-2" />

    <div class="mt-5">
      <div class="text-grey-darken-1">Message:</div>

      <VuetifyTiptap :model-value="update.message" class="mt-2" disabled flat hide-toolbar>
        <template #bottom> <div></div> </template>
      </VuetifyTiptap>
    </div>

    <div v-if="update.files?.length" class="mt-5">
      <div class="text-grey-darken-1 d-flex items-center">
        <v-icon class="mr-2"> mdi-attachment</v-icon>
        <span>Attachments:</span>
      </div>

      <file-uploading-grid :model-value="files" class="mt-2" disabled footer-class="bg-white"></file-uploading-grid>
    </div>

    <div
      v-else-if="isLoadOrUnloadCheckCallType"
      class="pa-8 border-grey-lighter bg-white d-flex align-center justify-center mt-3"
    >
      <span class="text-grey-darken-2">{{ t("updates.no-files-attached") }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
